import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { auth } from "../services/api";
import { BoxIcon } from "../components/Icons";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const { data } = await auth.login(email, password);
      localStorage.setItem("access_token", data.accessToken);
      localStorage.setItem("refresh_token", data.refreshToken);
      onLogin();

      // Redirect to intended path or home
      const redirectPath = searchParams.get("redirect") || "/";
      navigate(redirectPath, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--spacing-md)",
        background:
          "linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)",
      }}
    >
      <div className="card" style={{ maxWidth: "420px", width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: "var(--spacing-xl)" }}>
          <div
            className="sidebar-logo"
            style={{
              width: 56,
              height: 56,
              margin: "0 auto var(--spacing-md)",
              animation: "slideUp 0.6s ease-out",
            }}
          >
            <BoxIcon size={26} />
          </div>
          <h1
            style={{
              fontSize: "2.25rem",
              fontWeight: "700",
              letterSpacing: "-0.03em",
              marginBottom: "var(--spacing-sm)",
            }}
          >
            FrugalStack
          </h1>
          <p className="text-secondary">Inventory Management Made Simple</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div
              style={{
                padding: "var(--spacing-md)",
                background: "rgba(239, 68, 68, 0.1)",
                border: "1px solid var(--accent-danger)",
                borderRadius: "var(--radius-md)",
                color: "var(--accent-danger)",
                marginBottom: "var(--spacing-md)",
                fontSize: "0.875rem",
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={loading}
            style={{ width: "100%" }}
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
